var $, previousTryTrigger,
  slice = [].slice;

$ = window.jQuery;

previousTryTrigger = $.fn.tryTrigger;


/*
Simple plugin that will attempt to trigger an event for the given element. If
any listeners end up calling event.preventDefault() this method will return
false, otherwise true.

    element.on('some-event', (function(event) { return false }));
    element.tryTrigger('some-event');
    > false
    element.off('some-event');
    element.tryTrigger('some-event');
    > true
 */

$.fn.tryTrigger = function() {
  var args, event;
  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  event = $.Event.apply($, args);
  $(this).trigger(event);
  return !event.isDefaultPrevented();
};

$.fn.tryTrigger.noConflict = function() {
  $.fn.tryTrigger = previousTryTrigger;
  return this;
};
